import { vueThemingProps } from '@chakra-ui/vue-utils';
import { defineComponent, computed, h } from 'vue';
import { keyframes, useStyleConfig, chakra } from '@chakra-ui/vue-system';
import { CVisuallyHidden } from '@chakra-ui/c-visually-hidden';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var spin = keyframes({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});

var props = _extends({
  as: {
    type: [Object, String],
    "default": "div"
  },
  emptyColor: {
    type: String,
    "default": "transparent"
  },
  thickness: {
    type: String,
    "default": "2px"
  },
  speed: {
    type: String,
    "default": "0.45s"
  },
  color: {
    type: String
  },
  label: {
    type: String
  }
}, vueThemingProps);

var CSpinner = defineComponent({
  props: props,
  setup: function setup(props, _ref) {
    _ref.slots;
        var attrs = _ref.attrs;
    var themingProps = computed(function () {
      return {
        colorScheme: props.colorScheme,
        variant: props.variant,
        size: props.size,
        styleConfig: props.styleConfig
      };
    });
    return function () {
      var styles = useStyleConfig("Spinner", _extends({}, themingProps.value));

      var spinnerStyles = _extends({
        display: "inline-block",
        borderColor: "currentColor",
        borderStyle: "solid",
        borderRadius: "99999px",
        borderWidth: props.thickness,
        borderBottomColor: props.emptyColor,
        borderLeftColor: props.emptyColor,
        color: props.color,
        animation: spin + " " + props.speed + " linear infinite"
      }, styles.value);

      return h(chakra(props.as, {
        label: "spinner",
        __css: spinnerStyles
      }), _extends({}, attrs), props.label && function () {
        return [h(CVisuallyHidden, function () {
          return props.label;
        })];
      });
    };
  }
});
var CSpinner$1 = CSpinner;

export { CSpinner$1 as CSpinner };
